<template>
  <div>
    <!-- Sound Message -->
    <audio ref="soundMessage">
      <source :src="`${urlSoundMessage}.mp3`" type="audio/mpeg">
      <source :src="`${urlSoundMessage}.ogg`" type="audio/ogg">
      <embed hidden="true" autostart="true" loop="false" :src="`${urlSoundMessage}.mp3`">
    </audio>
    <!-- Sound Goal -->
    <audio ref="soundGoal">
      <source :src="`${urlSoundGoal}.mp3`" type="audio/mpeg">
      <source :src="`${urlSoundGoal}.ogg`" type="audio/ogg">
      <embed hidden="true" autostart="true" loop="false" :src="`${urlSoundGoal}.mp3`">
    </audio>
    <!-- Sound Silence -->
    <audio ref="soundSilence">
      <source :src="`${urlSoundSilence}.mp3`" type="audio/mpeg">
      <source :src="`${urlSoundSilence}.ogg`" type="audio/ogg">
      <embed hidden="true" autostart="true" loop="false" :src="`${urlSoundSilence}.mp3`">
    </audio>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      soundMessage: state => state.NotificationModule.soundMessage,
      soundGoal: state => state.NotificationModule.soundGoal,
      soundSilence: state => state.NotificationModule.soundSilence
    }),
    urlSoundMessage: () => `${process.env.VUE_APP_CDN_URL_APP}point-blank`,
    urlSoundGoal: () => `${process.env.VUE_APP_CDN_URL_APP}gol-gol-gol`,
    urlSoundSilence: () => `${process.env.VUE_APP_CDN_URL_APP}silence`
  },
  data() {
    return {
      unlock: false,
      sound: null
    }
  },
  mounted() {
    setTimeout(() => {
      document.getElementById("app").addEventListener('touchend', () => {
        this.unlockAudio()
      });
      document.getElementById("app").addEventListener('click', () => {
        this.unlockAudio()
      });
    }, 0)
  },
  methods: {
    unlockAudio() {
      if (this.unlock) {
        return 
      } else {
        this.unlock = true
      }

      this.$refs.soundMessage.muted = true;
      this.$refs.soundMessage.play();

      this.$refs.soundGoal.muted = true;
      this.$refs.soundGoal.play();
    }
  },
  watch: {
    'soundMessage': function(val) {
      if (val) {
        this.$refs.soundMessage.load();
        this.$refs.soundMessage.muted = false;
        this.$refs.soundMessage.play();
        this.$refs.soundMessage.addEventListener('canplay', function() {
          this.$refs.soundMessage.play();
        });
      } else {
        this.$refs.soundMessage.pause()
      }
    },
    'soundGoal': function(val) {
      if (val) {
        this.$refs.soundGoal.load()
        this.$refs.soundGoal.muted = false;
        this.$refs.soundGoal.play()
        this.$refs.soundGoal.addEventListener('canplay', function() {
          this.$refs.soundGoal.play();
        });
      } else {
        this.$refs.soundGoal.pause()
      }
    },
    "soundSilence": function(val) {
      if (val) {
        this.$refs.soundSilence.load()
        this.$refs.soundSilence.play()
      } else {
        this.$refs.soundSilence.pause()
      }
    }
  }
}
</script>

<style>

</style>